import { render, staticRenderFns } from "./play.vue?vue&type=template&id=b03b08dc"
import script from "./play.vue?vue&type=script&lang=js"
export * from "./play.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports